<template>
  <div
    class="modal fade"
    id="changePasswordModal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="changePasswordModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header shadow-sm ">
          <h6
            class="modal-title font-weight-bold text-light"
            id="changePasswordModalLabel"
          >
            <font-awesome-icon :icon="['fas', 'key']" class="media-icon mr-2" />
            Change Password
          </h6>
          <button
            type="button"
            class="close text-light"
            aria-label="Close"
            @click="closeModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body ">
          <div class="row m-0">
            <div class="col">
              <div class="form-group">
                <label class="small text-light" for="currentPassword">
                  Current Password
                </label>
                <input
                  type="password"
                  class="form-control form-control-default form-control-sm bg-dark-input"
                  id="currentPassword"
                  v-model="models.currentPassword"
                />
              </div>
            </div>
          </div>
          <div class="row m-0">
            <div class="col">
              <div class="form-group">
                <label class="small text-light" for="newPassword"> New Password </label>
                <input
                  type="password"
                  class="form-control form-control-default form-control-sm bg-dark-input"
                  id="newPassword"
                  v-model="models.newPassword"
                  @keydown.enter="saveChanges()"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer shadow ">
          <button
            type="button"
            class="btn btn-link btn-sm"
            @click="closeModal()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="saveChanges()"
            :disabled="isProcessing"
          >
            <div
              class="spinner-border spinner-border-sm text-light"
              v-if="isProcessing"
            ></div>
            <span v-else> Save </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import Swal from "sweetalert2";
import axios from "axios";

export default {
  name: "change-password-modal",
  props: ["show"],
  data() {
    return {
      isProcessing: false,
      models: {
        currentPassword: null,
        newPassword: null,
      },
      emptyModels: {
        currentPassword: null,
        newPassword: null,
      },
    };
  },
  watch: {
    show: {
      async handler() {
        if (this.show) {
          $("#changePasswordModal").modal("show");
          this.models = JSON.parse(JSON.stringify(this.emptyModels));
        } else {
          $("#changePasswordModal").modal("hide");
        }
      },
      immediate: true,
    },
  },
  methods: {
    closeModal() {
      if (!this.isProcessing) {
        this.$emit("close");
      }
    },
    saveChanges() {
      this.isProcessing = true;

      let user = localStorage.getItem("user");

      if (!user || !this.models.currentPassword || !this.models.newPassword) {
        this.isProcessing = false;

        return Swal.fire("Invalid password", "", "error");
      }

      API.post("password/reset", {
        identifier: JSON.parse(user).email,
        password: this.models.currentPassword,
        newPassword: this.models.newPassword,
      })
        .then((retVal) => {
          this.isProcessing = false;

          this.closeModal();

          this.$nextTick(() => {
            Swal.fire(
              "Password changed",
              "Your password has been successfully changed.<br />Please login again using your new password",
              "success"
            );

            localStorage.clear();

            this.$router.push({ name: "auth" });
          });
        })
        .catch((err) => {
          this.isProcessing = false;

          Swal.fire("Invalid password", "", "error");

          console.error(err);
        });
    },
  },
};
</script>